const channelManageRouter = {
  path: "/channel",
  name: "渠道管理",
  meta: { title: "渠道管理", icon: "el-icon-odometer" },
  redirect: "/channel/app",
  component: () => import("../../views/channelManage/index"),
  children: [
    {
      path: "/channel/app",
      name: "应用管理",
      meta: { title: "应用管理" },
      redirect: "/channel/app/list",
      component: () => import("../../views/channelManage/appManage/index"),
      children: [
        {
          path: "/channel/app/list",
          name: "应用列表",
          hidden: true,
          meta: { title: "应用列表", activePath: "/channel/app" },
          component: () => import("../../views/channelManage/appManage/list")
        },
        {
          path: "/channel/app/create",
          name: "新建应用",
          hidden: true,
          meta: {
            activePath: "/channel/app",
            title: "新建应用",
            layoutBackTo: "/channel/app/list",
            layoutBackLabel: "返回应用列表",
          },
          component: () =>
            import("../../views/channelManage/appManage/createOrEdit")
        },
        {
          path: "/channel/app/edit/:id",
          name: "编辑应用",
          hidden: true,
          meta: {
            activePath: "/channel/app",
            title: "编辑应用",
            layoutBackTo: "/channel/app/list",
            layoutBackLabel: "返回应用列表",
          },
          component: () =>
            import("../../views/channelManage/appManage/createOrEdit")
        },
        {
          path: "/channel/app/info/:id",
          name: "查看应用",
          hidden: true,
          meta: {
            activePath: "/channel/app",
            title: "查看应用",
            layoutBackTo: "/channel/app/list",
            layoutBackLabel: "返回应用列表",
          },
          component: () =>
            import("../../views/channelManage/appManage/info.vue")
        }
      ]
    },
    {
      path: "/channel/data",
      name: "数据集管理",
      meta: { title: "数据集管理" },
      redirect: "/channel/data/list",
      component: () => import("../../views/channelManage/dataManage/index"),
      children: [
        {
          path: "/channel/data/list",
          name: "数据集列表",
          hidden: true,
          meta: { activePath: "/channel/data", title: "数据集列表" },
          component: () => import("../../views/channelManage/dataManage/list")
        },
        {
          path: "/channel/data/create",
          name: "新建数据集",
          hidden: true,
          meta: {
            activePath: "/channel/data",
            title: "新建数据集",
            layoutBackTo: "/channel/data/list",
            layoutBackLabel: "返回数据集列表",
          },
          component: () =>
            import("../../views/channelManage/dataManage/createOrEdit")
        },
        {
          path: "/channel/data/edit/:id",
          name: "编辑数据集",
          hidden: true,
          meta: {
            activePath: "/channel/data",
            title: "编辑数据集",
            layoutBackTo: "/channel/data/list",
            layoutBackLabel: "返回数据集列表",
          },
          component: () =>
            import("../../views/channelManage/dataManage/createOrEdit")
        },
        {
          path: "/channel/data/info/:id",
          name: "查看数据集",
          hidden: true,
          meta: {
            activePath: "/channel/data",
            title: "查看数据集",
            layoutBackTo: "/channel/data/list",
            layoutBackLabel: "返回数据集列表",
          },
          component: () =>
            import("../../views/channelManage/dataManage/info.vue")
        }
      ]
    }
  ]
};
export default channelManageRouter;
